import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h2 } from '@helpers/typography';
import UmbracoFormStyles from '@stories/Components/UmbracoForm/UmbracoForm.styles';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div `
  color: var(--fgColor);
  position: relative;
`;
const ButtonContainer = styled.div ``;
const FormModal = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: ${rgba(brand.global.black, 0.5)};
  padding: ${fluid(70, 70)} ${fluid(10, 70)};

  display: none;
  justify-content: center;
  z-index: 10;

  &[data-show-modal='true'] {
    display: grid;
  }
`;
const FormModalInner = styled.div `
  background-color: ${brand.global.white};
  max-width: 1272px;
  width: 100%;
  max-height: 80vh;
  border-radius: 6px;
  padding: ${fluid(20, 60)} ${fluid(10, 70)} ${fluid(20, 60)} ${fluid(10, 60)};
  position: relative;
  text-align: left;
  margin: auto;
  overflow-y: scroll;
`;
const CloseBtn = styled.button `
  position: absolute;
  top: 50px;
  right: 15px;
  background: transparent;
  border: none;
  padding: 0;

  @media ${from(Device.Desktop)} {
    right: 30px;
  }

  @media ${until(Device.TabletLarge)} {
    top: auto;
    bottom: 100%;
    right: 10px;
    background-color: ${brand.global.white};
    border-radius: 6px 6px 0 0;
    padding: 8px 8px 0;
  }

  svg {
    width: 20px;
  }

  span {
    ${fonts.cabin.bold};
    display: block;
    text-transform: uppercase;
    font-size: 13px;
    line-height: 24px;
  }
`;
const ContentContainer = styled.div `
  overflow-y: auto;
  overflow-x: hidden;
  height: 100%;
  transform: translate3d(0, 0, 0);
  -webkit-overflow-scrolling: touch;
  padding-right: 20px;
`;
const ContentInner = styled.div ``;
const ContentWrapper = styled.div `
  position: relative;
`;
const Title = styled.h2 `
  ${h2}

  @media ${from(Device.TabletLarge)} {
    max-width: 80%;
  }
`;
const Content = styled.div `
  ${contentStyles};

  margin: 0 0 ${fluid(24, 42)};
`;
const FormWrapper = styled.div `
  margin-top: 30px;
  position: relative;

  ${UmbracoFormStyles.Form} {
    max-width: 100%;
  }

  ${UmbracoFormStyles.Input},
  ${UmbracoFormStyles.Textarea},
  ${UmbracoFormStyles.Select} {
    background-color: ${brand.global.white};
  }
`;
const FormModalStyles = {
    ButtonContainer,
    CloseBtn,
    Container,
    Content,
    ContentContainer,
    ContentInner,
    ContentWrapper,
    FormModal,
    FormModalInner,
    FormWrapper,
    Title,
};
export default FormModalStyles;
